export const AVAILABLE_LOCALIZATIONS = ['en', 'it']
